import React from 'react';
import { Button, Col, Container, Row, Table } from 'react-bootstrap';

import './styles/inviterecommend.css';

export default function inviteRecommend() {
  return (
    <>
      <div className="recommendation m-3">
        <Container>
            <Row>
                <div className="recommend_head d-flex justify-content-start mb-4">
                    <h2>Recommended</h2>
                </div>
                <Col>
                  <div className="recommend_col">
                    <div className="recommend_btns d-flex gap-4">
                        <div className="recommend_btn">
                            <Button className='active'>Overview</Button>
                        </div>
                        <div className="recommend_btn">
                            <Button>Spot</Button>
                        </div>
                        <div className="recommend_btn">
                            <Button>Futures</Button>
                        </div>
                    </div>
                    <Table responsive className='text-start mt-3'>
                        <thead className='invite_recommend_thead'>
                            <tr>
                                <th className='border-bottom-0'>Friend ID</th>
                                <th className='border-bottom-0'>Commission Income(USDT)</th>
                                <th className='border-bottom-0'>Dates</th>
                            </tr>
                        </thead>
                        <tbody>

                        </tbody>
                    </Table>

                    <div>
                        <div className="invite_recommend_content d-flex justify-content-between align-items-center">
                           <div className="invite_recommend_content_para">
                            <p>Displays all data from the past day. To view detailed transaction history, click "Export".</p>
                           </div>
                           <div className="invite_recommend_content_link">
                            <a target='blank'>Export</a>
                           </div>
                        </div>
                    </div>
                  </div>
                </Col>
            </Row>
        </Container>
      </div>
    </>
  )
}
